import { Dialog as DialogPrimitive } from 'bits-ui';
import Content from './dialog-content.svelte';

const Root = DialogPrimitive.Root;
const Trigger = DialogPrimitive.Trigger;
const Close = DialogPrimitive.Close;
const Title = DialogPrimitive.Title;
const Description = DialogPrimitive.Description;

export {
  Root,
  Trigger,
  Close,
  Content,
  Title,
  Description,
  Root as Dialog,
  Trigger as DialogTrigger,
  Close as DialogClose,
  Content as DialogContent,
  Title as DialogTitle,
  Description as DialogDescription,
};
